import { render } from "./search-outline-footer.vue?vue&type=template&id=b2f2b2aa&scoped=true&ts=true"
import script from "./search-outline-footer.vue?vue&type=script&lang=ts"
export * from "./search-outline-footer.vue?vue&type=script&lang=ts"

import "./search-outline-footer.vue?vue&type=style&index=0&id=b2f2b2aa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2f2b2aa"]])

export default __exports__